import React, { useState, useEffect } from "react";
import {
  IonContent,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonList,
  IonItemGroup,
  IonItemDivider,
  IonLabel,
  IonRefresherContent,
  IonRefresher,
} from "@ionic/react";

import Header from "./Header";
import PatientItem from "./PatientItem";
import { useDispatch, useSelector } from "react-redux";
import { setSearchValue } from "./patientsSlice";
import { setActivePatient } from "../patient/patientSlice";
import Logo from "../../components/Logo";
import Empty from "../../components/Empty";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { listPatients, listLongHospitalizedPatients } from "../../api/server";
import { useHistory } from "react-router-dom";
import { chevronDownCircleOutline } from "ionicons/icons";
import moment from "moment";
const groupBy = require("lodash/groupBy");

const Patients = (props) => {
  const { routerRef } = props;
  const [tableItems, setTableitems] = useState([]);
  const [refresherEvent, setRefresherEvent] = useState(null);
  const [counter, setCounter] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const intl = useIntl();
  const { page: patientsPage, searchValue, patientsFilter } = useSelector(
    (state) => state.patients
  );
  const { scopePrefix, profile, activeBranch } = useSelector(
    (state) => state.auth
  );

  const { activeMonth } = useSelector((state) => state.visits);

  let from = moment(activeMonth).startOf("month").format();
  let to = moment(activeMonth).endOf("month").format();

  let andFilter = [];
  switch (patientsFilter) {
    case "active_and_candidates":
      andFilter = [{ $or: [{ status_id: 1 }, { status_id: 3 }] }];

      break;

    case "not_active":
      andFilter = [{ $or: [{ status_id: 2 }] }];
      break;

    case "long_hospitalized":
      andFilter = [];
      break;

    default:
      break;
  }

  const newState = {
    ...patientsPage,
    filter: {
      freeText: searchValue,
      $and: andFilter,
    },
    query: {
      from,
      to,
      branch: activeBranch,
    },
    employeeId: profile.associated_employee_id,
  };

  const { isFetching, data } = useQuery(
    [
      searchValue,
      patientsFilter,
      scopePrefix,
      andFilter,
      scopePrefix,
      history.location,
      counter,
      activeMonth,
    ],
    async () => {
      const fetch =
        patientsFilter === "active_and_candidates" ||
        patientsFilter === "not_active"
          ? listPatients
          : listLongHospitalizedPatients;
      const result = await fetch({
        ...newState,
        scopePrefix,
      });
      return patientsFilter === "active_and_candidates" ||
        patientsFilter === "not_active"
        ? result.data.items
        : result.data;
    },
    {
      keepPreviousData: true,
      staleTime: 0,
      enabled: history.location.pathname === "/app/patients",
    }
  );

  const onShowPatientCard = (record) => {
    dispatch(setActivePatient({ record: record }));
  };

  useEffect(() => {
    const grouped = groupBy(data, (dt) => dt.surename.charAt(0));
    setTableitems(grouped);
  }, [data]);

  const onSearch = (val) => {
    dispatch(setSearchValue(val));
  };

  useEffect(() => {
    if (!isFetching && refresherEvent) {
      refresherEvent.detail.complete();
      setRefresherEvent(null);
    }
  }, [isFetching]);

  const doRefresh = (event) => {
    setRefresherEvent(event);
    setCounter(counter + 1);
  };

  return (
    <IonPage>
      <IonToolbar color="primary">
        <IonButtons slot="primary">
          <Logo />
        </IonButtons>
        <IonTitle>
          {intl.formatMessage({
            id: "app.mobile.titles.patients",
          })}
        </IonTitle>
      </IonToolbar>
      <div style={{ display: "flex", height: "100%", flexDirection: "column" }}>
        <Header
          visits={data}
          patientsFilter={patientsFilter}
          onSearch={onSearch}
          loading={isFetching}
        />
        <IonContent>
          <IonContent>
            <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
              <IonRefresherContent
                pullingIcon={chevronDownCircleOutline}
                refreshingSpinner="lines"
              ></IonRefresherContent>
            </IonRefresher>
            {Object.keys(tableItems).length > 0 ? (
              <IonList>
                {Object.keys(tableItems).map((key) => {
                  return (
                    <IonItemGroup key={key}>
                      <IonItemDivider>
                        <IonLabel>{key}</IonLabel>
                      </IonItemDivider>
                      {tableItems[key].map((item) => (
                        <PatientItem
                          key={item.id}
                          item={item}
                          onShowPatientCard={onShowPatientCard}
                          routerRef={routerRef}
                        />
                      ))}
                    </IonItemGroup>
                  );
                })}
              </IonList>
            ) : (
              <Empty
                title={intl.formatMessage({
                  id: "app.mobile.no_result_title",
                })}
                subTitle={intl.formatMessage({
                  id: "app.mobile.no_result_sub_title",
                })}
                loading={isFetching}
              />
            )}
          </IonContent>
        </IonContent>
      </div>
    </IonPage>
  );
};

export default Patients;
